import { render, staticRenderFns } from "./MyNews.vue?vue&type=template&id=e0a0c726&"
import script from "./MyNews.vue?vue&type=script&lang=js&"
export * from "./MyNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports